import { describeKnowledgeApiError } from 'utils/knowledgeErrors';
import createNamedContext from 'utils/createNamedContext';
import { memo, PropsWithChildren, useContext, useState } from 'react';
import { useRequest } from 'ahooks';
import type { SpuClass } from './type';
import { getSpuClass } from './api';
import { useTranslate } from '@tolgee/react';
import { message } from 'antd';
import { get } from 'lodash-es';

interface SpuClassContextType {
  loading: boolean;
  activeIndex: number;
  list: SpuClass[];
  activeSpuClass: SpuClass | undefined;
  setActiveIndex: (index: number) => void;
}

const SpuClassContext = createNamedContext<SpuClassContextType>('SpuClassContext', null!);

export const useSpuClassContext = () => {
  const value = useContext(SpuClassContext);

  if (!value) {
    throw new Error(
      'useSpuClassContext hook should be used in a context of SpuClassProvider component',
    );
  }

  return value;
};

const SpuClassProvider = memo((props: PropsWithChildren<{}>) => {
  const { children } = props;
  const { t } = useTranslate();
  const [activeIndex, setActiveIndex] = useState(0);
  const { data, loading } = useRequest(getSpuClass, {
    onError: (knowledgeError) => {
      message.error(
        describeKnowledgeApiError(knowledgeError, undefined, t('phrase.获取数据失败，请稍后再试')),
      );
    },
  });
  const activeSpuClass = get(data, activeIndex);
  return (
    <SpuClassContext.Provider
      value={{
        loading,
        list: data || [],
        activeIndex,
        activeSpuClass,
        setActiveIndex,
      }}
    >
      {children}
    </SpuClassContext.Provider>
  );
});

export default SpuClassProvider;

SpuClassProvider.displayName = 'SpuClassProvider';
